import { useMemo } from 'react';

import useForm from '../utils/useForm';

const useCheckInfoForm = (onSubmit, values) => {
  const fields = useMemo(
    () => [
      {
        title: 'Check Info',
        isTitleHidden: true,
        fields: [
          {
            title: 'Check Number',
            name: 'check_disbursement_data.check_number',
            type: 'text',
            readOnly: true,
          },
          {
            title: 'Check Date',
            name: 'check_disbursement_data.check_date',
            type: 'date',
            readOnly: true,
          },
          {
            title: 'Arrives By Date',
            name: 'check_disbursement_data.arrives_by_date',
            type: 'date',
            readOnly: true,
          },
          {
            title: 'Cleared Date',
            name: 'check_disbursement_data.cleared_date',
            type: 'date',
            readOnly: true,
          },
          {
            title: 'Amount',
            name: 'check_disbursement_data.amount',
            type: 'currency',
            readOnly: true,
          },
          {
            title: 'Memo',
            name: 'check_disbursement_data.memo',
            type: 'text',
            readOnly: true,
          },
          {
            title: 'Expiration Date',
            name: 'check_disbursement_data.expiration_date',
            type: 'date',
            readOnly: true,
          },
          {
            title: 'Tracking Info',
            name: 'check_disbursement_data.tracking_info',
            type: 'text',
            readOnly: true,
          },
          {
            title: 'Delivery Type Actual',
            name: 'check_disbursement_data.delivery_type_actual',
            type: 'text',
            readOnly: true,
          },
          {
            title: 'Returned Date',
            name: 'check_disbursement_data.returned_date',
            type: 'date',
            readOnly: true,
          },
          {
            title: 'Payee Address',
            name: 'check_disbursement_data.payee_address',
            type: 'text',
            readOnly: true,
          },
          {
            title: 'Error',
            name: 'check_disbursement_data.error_code',
            type: 'text',
            readOnly: true,
          },
        ],
      },
    ],
    []
  );

  return useForm({ fields, onSubmit, values });
};

export default useCheckInfoForm;
